export default () => {
    const map = document.querySelector('.js-map')

    if (!map) {
        return
    }

    // get coordinates from html data attribute
    let lat = 52.19639058469054
    let lng = 5.5316983233631944
    let locations = []

    if (map.dataset.locations) {
        locations = JSON.parse(map.dataset.locations)
    }

    // add google maps script
    const script = document.createElement('script')
    const apiKey = 'AIzaSyAZQ6StK7wgYRJqUbyENH6OPKajl6KKOkQ'
    script.src = `https://maps.googleapis.com/maps/api/js?v=3.exp&key=${apiKey}&callback=mapsCallback`
    document.body.appendChild(script)

    window.mapsCallback = () => {
        if (map) {
            displayMap(lat, lng, locations)
        }
    }

    const displayMap = (lat, lng, locations) => {
        let location = new window.google.maps.LatLng(lat, lng)

        const map = new window.google.maps.Map(
            document.getElementById('maps'),
            {
                zoom: 7,
                center: location,
                scrollwheel: false,
                draggable: true,
                zoomControl: true,
                scaleControl: false,
                mapTypeControl: false,
                fullscreenControl: false,
                streetViewControl: false,
                styles: [
                    {
                        featureType: 'road',
                        elementType: 'geometry',
                        stylers: [
                            { lightness: 10 },
                            { visibility: 'simplified' }],
                    },
                    {
                        featureType: 'road',
                        elementType: 'labels',
                    },
                    {
                        featureType: "poi",
                        elementType: "labels",
                        stylers: [
                            { visibility: "off" }
                        ]
                    }
                ],
            },
        )

        locations.forEach(function (location) {
            new window.google.maps.Marker({
                map: map,
                position: {
                    lat: parseFloat(location.lat),
                    lng: parseFloat(location.lng),
                },
                icon: {
                    labelOrigin: new google.maps.Point(75, 32),
                    size: new google.maps.Size(32,32),
                    anchor: new google.maps.Point(16,32)
                },
            })
        });
    }
}

// WEBPACK FOOTER //
// ./src/js/modules/Maps.js
